// Shared constants for Microsoft Teams call scheduling (Call Schedule card,
// My Calls calendar, and any other surface that lists/booked Teams calls).

// Business-day window the time grid renders, and slot granularity.
export const DAY_START_HOUR = 9;
export const DAY_END_HOUR = 21;
export const SLOT_MINUTES = 30;

// Calls can be scheduled at most this many months ahead — bounds the calendar
// (year navigation is unnecessary within this window).
export const MAX_MONTHS_AHEAD = 3;

// A Teams call blocks the organizer's time only while it is live/upcoming.
export const BLOCKING_STATUSES = ["scheduled", "in_progress"];

// Durations (minutes) offered when booking a call.
export const DURATION_OPTIONS = [15, 30, 45];

// antd Tag color per (normalised) call status — see telephony-service's
// normalizeCallStatus for the status keys.
export const CALL_STATUS_COLORS = {
    scheduled: "blue",
    in_progress: "green",
    completed: "geekblue",
    artefacts_pending: "gold",
    cancelled: "red",
    failed: "volcano"
};

// Avatar/name gradient per transcript speaker, assigned in order of first
// appearance.
export const SPEAKER_COLORS = [
    ["#0f9d63", "#0b7346"],
    ["#9333ea", "#6b21a8"],
    ["#ea580c", "#c2410c"],
    ["#0e9494", "#0f766e"],
    ["#db2777", "#be185d"],
    ["#4f46e5", "#3730a3"]
];
